 <template>
  <el-row class="el-row_h">
    <el-col :span="24">
      <div class="grid-content bg-purple-dark layout_box flex s_bg" style="overflow: auto">
        <el-input style="min-width: 150px" placeholder="请输入用户关键字搜索" v-model="keyWord" clearable size="small" class="s_padding filterSelect">
        </el-input>
        <el-select v-model="DirectionValue" placeholder="请选择" class="s_padding" size="small" style="width:80px;min-width: 80px">
          <el-option v-for="item in DirectionList" :key="item.Code" :label="item.Name" :value="item.Code">
          </el-option>
        </el-select>
        <dateRangeHis ref="dateRange"></dateRangeHis>
        <el-button type="primary" icon="el-icon-search" size="small" @click="getList()">查询</el-button>
      </div>
      <div style="height: 100%;">
        <tableCom :data="withdrawDetailList" v-loading="loading"></tableCom>
      </div>
      <div class="pagination_mb2 text-center">
        <pagination :pagerPro="Pager" @ee="pageFn"></pagination>
      </div>
      <div class="footer grid-content bg-purple layout_box">
        <span class="text-right">
          入金合计:
          <span class="capital">{{SubAccountLimit ? totalCapital : "***"}}</span>
          <span class="Currency"> ({{CurrencyName}})</span>
          &nbsp;&nbsp;&nbsp; 提现合计:
          <span class="capital">{{SubAccountLimit ? totalCurrency : "***"}}</span>
          <span class="Currency"> ({{CurrencyName}})</span>
        </span>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import tableCom from "./withdrawalDetailT.vue";
import pagination from "../../paging.vue";
import dateRangeHis from "../../dateRangeSubHis.vue";
import SeachConPage from "../SeachConPage.vue";

export default {
  // 出入金明细
  name: "withdrawalDetailS",
  props: ["agentID"],
  components: {
    tableCom,
    pagination,
    dateRangeHis,
    SeachConPage
  },
  data() {
    return {
      loading: "",
      Pager: {
        PageNo: 1,
        PageSize: 10,
        RecordCount: 0
      },
      DirectionList: [{ Code: 1, Name: "入金" }, { Code: 2, Name: "出金" }],
      withdrawDetailList: [],
      DirectionValue: 1,
      totalCapital: 0,
      totalCurrency: 0,
      keyWord: "",
      SubAccountLimit: true,
      CurrencyName: '',
    };
  },
  mounted() {
    if (sessionStorage.getItem("type") == "1"){
      if (sessionStorage.getItem("SubAccountLimit") != null && sessionStorage.getItem("SubAccountLimit") != "undefined") {
        this.SubAccountLimit = JSON.parse(sessionStorage.getItem("SubAccountLimit"));
      }
    }
    this.DirectionValue = this.DirectionList[0].Code;
    this.getList();
    this.getCurrencyName();
  },
  methods: {
    getCurrencyName() {
      var url = "/Account/GetInsBasicCurrency";
      var post = "";
      this.$loginapi.post(url, post, response => {
        if (response.Ret == 0) {
          this.CurrencyName = response.Data.Name;
        } else {
          this.$alert(response.Msg, {});
        }
      });
    },
    getList(isSearch = true) {
      if (isSearch) {
        this.Pager = {
          PageNo: 1,
          PageSize: 20,
          RecordCount: 0
        };
      }
      this.queryobj={
        UserKey:this.keyWord,
        MoneyTransType: this.DirectionValue,
        BeginDate: this.$refs.dateRange.DateRangeValue[0],
        EndDate: this.$refs.dateRange.DateRangeValue[1],
      }
      this.$emit("withdrawalDetail", this.queryobj);
      this.loading = true;
      let url = "/report/QueryAgentUserHistoryMoneyTransfer";
      let postData = {
        AgentIds: this.agentID,
        UserKey: this.keyWord,
        MoneyTransType: this.DirectionValue,
        BeginDate: this.$refs.dateRange.DateRangeValue[0],
        EndDate: this.$refs.dateRange.DateRangeValue[1]
      };
      this.$loginapi.postWithPage(
        url,
        this.Pager.PageNo,
        this.Pager.PageSize,
        postData,
        response => {
          this.loading = false;
          if (response.Ret == 0) {
            this.withdrawDetailList = response.Data.ListDetail;
            $.each(this.withdrawDetailList, function(i, n) {
              // alert("索引"+i+"对应的值"+n);
              let YMD = n.OptDate.split("/");
              YMD = YMD[2] + "-" + YMD[0] + "-" + YMD[1];
              n.OptDate = YMD;
            });
            this.totalCapital = response.Data.TransferTotal.EntityTotal;
            this.totalCurrency = response.Data.TransferTotal.OutTotal;

            if (this.Pager.PageNo == 1) {
              this.Pager = response.Pager;
            }
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    pageFn(size, PageNo) {
      this.Pager.PageSize = size;
      this.Pager.PageNo = PageNo;
      this.getList(false);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/selects/withdrawalDetail/withdrawalDetailS.vue